import { Link } from "react-router";
import { useTranslate } from "ra-core";

import type { useOverdueRackets } from "./racketHooks";
import { HolderName } from "./RelatedLoans";

// "Segnalazioni" of the Today screen (task 1.10b, D-040): test rackets of
// loans made by the person that are overdue, past the expected return or
// past 60 days without one, for any purpose. The team view shows them for
// the person picked.

export const RacketSignals = ({
  rackets,
}: {
  rackets: ReturnType<typeof useOverdueRackets>;
}) => {
  const translate = useTranslate();
  return (
    <ul className="flex flex-col gap-1">
      {rackets.map((racket) => (
        <li key={racket.id} className="text-sm">
          <Link to={`/test_rackets/${racket.id}/show`} className="underline">
            {translate("tenax.rackets.signals.overdue", {
              code: racket.code,
              smart_count: racket.days_since ?? 0,
            })}
          </Link>{" "}
          <HolderName
            contactId={racket.holder_contact_id}
            companyId={racket.holder_company_id}
            link={false}
          />
        </li>
      ))}
    </ul>
  );
};
